// @flow

// Libs
import _some from 'lodash/some'
import _map from 'lodash/map'
import _uniqueId from 'lodash/uniqueId'
import _size from 'lodash/size'
import React from 'react'

// Components
import Mask from 'fc-masks'
import ImportJobsForm from './ImportJobsForm'
import ImportJobsPopup from './ImportJobsPopup'

// Operations
import { ImportJobsToolOperation } from 'hfty-operator-import-jobs-tool/types'
import { ImportJobsPopupOperation } from 'hfty-operator-import-jobs-popup/types'

// Styles
import {tool as styles} from './styles'

// Types
type Props = {
  updateImportJobsToolOperation: Function,
  importJobsToolOperations: Array<ImportJobsToolOperation>,
  importJobsPopupOperations: Array<ImportJobsPopupOperation>,
  seasonOptions: Array<Object>,
  closePopup: Function,
  onCancel: Function,
  onSubmit: Function,
}

export default function ImportJobsTool (props: Props): React.Element<any> {
  const {
    updateImportJobsToolOperation,
    importJobsPopupOperations,
    importJobsToolOperations,
    seasonOptions,
    closePopup,
    onCancel,
    onSubmit,
  } = props
  const isSubmitting = _some(importJobsToolOperations,
    (operation: ImportJobsToolOperation): boolean => operation.submitting)

  return (
    <div>
      <Mask enabled={isSubmitting} style={styles.mask} spinnerName='three-bounce' />
      {_map(importJobsToolOperations, (importJobsToolOperation: ImportJobsToolOperation): React.Element<any> => {
        return (
          <ImportJobsForm
            key={_uniqueId('importJobTool')}
            importJobsToolOperation={importJobsToolOperation}
            importJobsToolOperations={importJobsToolOperations}
            updateImportJobsToolOperation={updateImportJobsToolOperation}
            seasonOptions={seasonOptions}
            onSubmit={onSubmit}
            onCancel={onCancel}
          />
        )
      })}
      {_map(importJobsPopupOperations, (popupOperation: ImportJobsPopupOperation): React.Element<any> => {
        return (
          <ImportJobsPopup
            key={_uniqueId('importJobPopup')}
            importJobsPopupOperation={popupOperation}
            importJobsPopupOperations={importJobsPopupOperations}
            isOpen={_size(importJobsPopupOperations) > 0}
            onClose={closePopup}
          />
        )
      })}
    </div>
  )
}
